module.exports = __webpack_public_path__ + "img/ubyt_b.017ef5d7.svg";